import React from "react";
import { all_routes } from "../../router/all_routes";
// import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Link, useLocation } from "react-router-dom";

const DashboardMenu = () => {
  const routes = all_routes;
  const location = useLocation();
  const isLinkActive = (route: string) => {
    // Check if the current location matches the given route
    return location.pathname === route;
  };
  return (
    <>
      <div className="container py-1 px-3">
        {/* <div className="sign-group py-1 px-1">
          <Link to={routes.homeOne} className="border-0 text-primary-dark d-flex align-items-center mb-0">

            <i className="bx bx-arrow-back fs-5 me-2"></i>

            <span className=""> Back</span>
          </Link>
        </div> */}
      </div>

      <div className="dashboard-section">
        <div className="container">


          <div className="row">
            <div className="col-lg-12">
              <div className="dashboard-menu">
                <ul className="row">
                  {/* <li>
                    <Link to={routes.userDashboard} className={isLinkActive(routes.userDashboard) ? "active" : ""}>
                      <ImageWithBasePath
                        src="assets/img/icons/dashboard-icon.svg"
                        alt="Icon"
                      />
                      <span>Dashboard</span>
                    </Link>
                  </li> */}
                  <li  className="col-4 pe-0">
                    <Link to={routes.userBookings} className={isLinkActive(routes.userBookings) || isLinkActive(routes.userBookingInprogress) || isLinkActive(routes.userBookingUpcoming) || isLinkActive(routes.userBookingComplete) || isLinkActive(routes.userBookingCancelled) ? "active" : ""}>
                      {/* <ImageWithBasePath
                        src="assets/img/icons/booking-icon.svg"
                        alt="Icon"
                      /> */}
                      <span className="text-nowrap">My Bookings</span>
                    </Link>
                  </li>

                  <li  className="col-4 pe-0">
                    <Link to={routes.userPayment} className={isLinkActive(routes.userPayment) ? "active " : ""}>


                      {/* <span className={isLinkActive(routes.userPayment) ? " " : "opacity-50"}>

                        <ImageWithBasePath
                          src="assets/img/icons/dollar.svg"
                          alt="Icon"
                          width={"28px"}
                          height={"28px"}
                        />

                      </span> */}

                      <span>Payments</span>
                    </Link>
                  </li>
                  <li  className="col-4">
                    <Link to={routes.userSettings} className={isLinkActive(routes.userSettings) || isLinkActive(routes.userSecurity) || isLinkActive(routes.preference) || isLinkActive(routes.notification) || isLinkActive(routes.userIntegration) ? "active " : ""}>

                      {/* <span className={isLinkActive(routes.userSettings) || isLinkActive(routes.userSecurity) || isLinkActive(routes.preference) || isLinkActive(routes.notification) || isLinkActive(routes.userIntegration) ? "" : "opacity-50"}>
                        <ImageWithBasePath
                          src="assets/img/icons/person-fill-gear.svg"
                          alt="Icon"
                          width={28}
                          height={28}
                        />
                      </span> */}
 
                      <span>Settings</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardMenu;